module.exports = __webpack_public_path__ + "media/Components/fonts/VastShadow-b99f00512eac4913d7925bb98b087f19.ttf";